<!--
검수시요청사항 라벨 컴포넌트
-->
<script>
    export default {
        props: {
            /**
             * 상품ID
             */
            prodId: {
                type: Number,
            },
        },
        data: function () {
            return {
                /**
                 * 데이터 로드 상태
                 *  - unload
                 *  - loading
                 *  - laoded
                 */
                loadState: 'unload',

                /**
                 * (bool)
                 * 팝업 display 상태
                 */
                viewDisplay: false,

                /**
                 * (array)
                 * 검수시요청사항 object 배열
                 *
                 * [
                 *  {id:1, request:요청사항 ...},
                 *  {id:2, request:요청사항 ...},
                 * ]
                 */
                checkRequests: [],
            };
        },
        computed: {
        },
        methods: {

            /**
             * 모듈로드
             */
            load() {
                if (this.loadState !== 'unload') {
                    return;
                }

                this.loadState = 'loading';
                // ajax 옵션
                let cmp = this;
                let opts = {
                    type: 'get',
                    url: '/prods/' + this.prodId + '/check-requests',
                    data: {
                        _token: this.csrfToken,
                    },
                    dataType: 'json',
                    success(response, textStatus, jqXHR) {
                        cmp.checkRequests = response.check_requests;
                        cmp.loadState = 'loaded';
                    },
                    alert_error_msg(msg) {
                        alert(msg);
                        cmp.loadState = 'unload';
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            },

            /**
             * 팝업열기
             * @return void
             */
            openView() {
                this.viewDisplay = true;

                // 데이터 로드
                if (this.loadState === 'unload') {
                    this.load();
                }
            },

            /**
             * 팝업닫기
             * @return void
             */
            closeView() {
                this.viewDisplay = false;
            },
        },
    }
</script>